import {memo} from "react";
import {Template} from "../../../components/template/template.jsx";
import {Card} from "../../../components/card/card.jsx";
import "../../../css/style-dashboards.css";
import useSse from "./hooks/use-sse.js";
import VehiclePassagesCard from "./components/vehicle-passages/vehicle-passages-card.jsx";
import MonitoringCard from "./components/monitoring/monitoring-card.jsx";
import UsersCard from "./components/users/users-card.jsx";
import LanesCard from "./components/lanes/lanes-card.jsx";


const VehiclesSection = memo(function VehiclesSection({ passagesData }) {
    return <VehiclePassagesCard passagesData={passagesData} />
});

const UsersAndLanesSection = memo(function UsersAndLanesSection({ usersData, lanesData }) {
    return (
        <Card className="dash-main-card col-span-19 row-span-1 min-h-0 min-w-0">
            <section className="grid h-full min-h-0 grid-cols-5 gap-[20px]">
                <UsersCard usersData={usersData} />
                <LanesCard lanesData={lanesData} />
            </section>
        </Card>
    );
});

const MonitoringSection = memo(function MonitoringSection({ monitoringData }) {
    return <MonitoringCard monitoringData={monitoringData} />
});

export default function DashboardWall() {
    const { dashboardData, lanesData } = useSse();

    const passagesData = dashboardData?.passages;
    const usersData = dashboardData?.users;
    const monitoringData = dashboardData?.monitoring;

    return (
        <Template className="dash" isLoading={!dashboardData}>
            <Template.Header className="bg-transparent! border-b-0!">
                <Template.Title className="text-[#F4FFFF]!">
                    Dashboard Muralha - Últimas 24h
                </Template.Title>
            </Template.Header>
            <Template.Body
                className="dash-body dashboard-wall-body h-[calc(100vh-69px)] grid grid-cols-48 grid-rows-[minmax(0,1fr)_minmax(0,1fr)] relative gap-x-(--dash-gap-md) gap-y-(--dash-gap-md)">
                {dashboardData && (
                    <>
                        <VehiclesSection passagesData={passagesData} />

                        <UsersAndLanesSection usersData={usersData} lanesData={lanesData} />

                        <MonitoringSection monitoringData={monitoringData} />
                    </>
                )}
            </Template.Body>
        </Template>
    )
}
